module.exports = __webpack_public_path__ + "static/media/minimize.4757b247.svg";